(function(global){
  const plans={mattress:{low:58918605488502,high:58918605521270},furniture:{low:58918606373238,high:58918606406006}};
  const prices={mattress:{low:9900,high:11900},furniture:{low:6900,high:8900}};
  const planIds=new Set(Object.values(plans).flatMap(Object.values).map(String));
  const services=new Set(['15853952303478','15853952336246']);
  const protectors={Single:{id:58943959564662,price:4000},Double:{id:58943959597430,price:6000},King:{id:58943959630198,price:6000},'Super King':{id:58943959662966,price:7000}};
  protectors['Super King (Zip & Link)']=protectors['Super King'];
  const type=item=>String(item.product_type||'').toLowerCase().trim();
  const isPlan=item=>planIds.has(String(item.variant_id||item.id));
  const isMattress=item=>['mattress','mattresses'].includes(type(item));
  const isEligible=item=>isMattress(item)||['headboard','headboards','bed frame','bed frames','divan base','divan bases'].includes(type(item));
  const isService=item=>services.has(String(item.product_id))||['service','services','delivery','delivery service'].includes(type(item));
  function quote(items){
    const products=items.filter(item=>!isPlan(item)&&!isService(item));
    const total=products.reduce((sum,item)=>sum+Number(item.original_line_price??Number(item.price)*Number(item.quantity)),0);
    const eligible=products.filter(isEligible);
    const mattresses=eligible.filter(isMattress);
    const kind=mattresses.length?'mattress':'furniture';
    const band=total>=150100?'high':'low';
    return {total,kind,band,id:plans[kind][band],price:prices[kind][band],eligible,mattresses,plans:items.filter(isPlan),protectorCount:mattresses.reduce((n,i)=>n+Number(i.quantity),0),supported:eligible.length>0};
  }
  function signature(items){const quantities=new Map();for(const i of items.filter(isEligible)){const id=String(i.variant_id||i.id);quantities.set(id,(quantities.get(id)||0)+Number(i.quantity));}return JSON.stringify([...quantities].sort((a,b)=>a[0].localeCompare(b[0])));}
  function invalidPlans(items){
    const q=quote(items);
    return q.plans.filter((p,i)=>!q.supported||i>0||Number(p.variant_id||p.id)!==q.id||p.quantity!==1||p.parent_relationship||p.properties?._tms_order_plan!=='true'||p.properties?._tms_furniture!==signature(items));
  }
  const api={plans,prices,protectors,isPlan,isMattress,isEligible,isService,quote,signature,invalidPlans};
  if(typeof module!=='undefined')module.exports=api;
  else global.TMSGuardsmanOrder=api;
})(typeof window!=='undefined'?window:this);

